import { Injectable } from '@angular/core';
import { MsgBoxService } from '../msg-boxes/msg-box.service';
import { msgHandlers, msgHandlersNumber } from './msgHandler';
import { MsgMngr } from '../common/MsgMngr';
import { AppConfig } from '../app.config';
import { dateInputsHaveChanged } from '@angular/material/datepicker/datepicker-input-base';
import { BehaviorSubject } from 'rxjs';
import { ThemeService } from 'ng2-charts';
import { DatePipe } from '@angular/common';
import * as consts from './../common/consts';
import * as enums from './../common/enums';
import * as projMsgs from 'src/app/msg/projMsgs';

@Injectable({
  providedIn: 'root'
})
export class MsgMngrService extends MsgMngr {

  private counter: number;
  private lastCounterTime: number;
  private totalBytes: number;
  private quiet: boolean = false;
  public isPlayback: boolean = false;
  public messageToBanner :string = '';

  constructor(
    private msgBoxSrv: MsgBoxService, 
    private datePipe: DatePipe) {
    super();
  }

  async openWebSocket(quiet?: boolean, retry?: boolean) {
    super.openWebSocket(retry);

    this.counter = 0;
    this.lastCounterTime = Date.now();
    this.totalBytes = 0;
    this.quiet = quiet;
  }

  invokeHandleMsgByType(msgType: consts.SIGNAL_R_MSG_TYPE, msgObj){
    let msgNum = msgHandlersNumber.indexOf(consts[msgType] as number);

    if(!msgNum){
      if (AppConfig.settings.ShowLogs)
      console.log(`[${MsgMngrService.name}] Msg: ${msgType} Does Not Exist in the System...`);
     return;
    }

    msgHandlers[msgNum].handleMsg(msgObj);
}

  protected onMessage(evt: MessageEvent) {
    let msgEvt: MessageEvent = evt;
    let receivedMsg: string = msgEvt.data;
    // keep alive handling
    if (receivedMsg == '') {
      if (AppConfig.settings.ShowLogs)
        console.log(`[${MsgMngrService.name}] msgType not parsed`);
      return;
    }
    let msgObj = JSON.parse(receivedMsg);
    this.totalBytes += receivedMsg.length;
    if (msgObj.MessageType) {
      let MsgNum = msgHandlersNumber.indexOf(msgObj.MessageType);
      if (MsgNum == -1) {
        if (AppConfig.settings.ShowLogs) {
          console.error("Msg: " + msgObj.MessageType + " Does Not Exist in the System...  " + msgObj);
          return;
        }
      }
     
      else{
        msgHandlers[MsgNum].handleMsg(msgObj);
      }
    }
    
    // start a timed function
    // make a function that will run once every 1 second or 1000 and will change the date observable
    if (AppConfig.settings.ShowLogs) {
      if (Date.now() - this.lastCounterTime > 10000) {
        this.counter++;
        if (AppConfig.settings.ShowLogs)
          console.debug(`Received ${this.counter} messages in 10 seconds, total ${this.totalBytes} bytes`);
        this.counter = 0;
        this.totalBytes = 0;
        this.lastCounterTime = Date.now();
      }
    }
  }

  protected onClose() {
    if (this.connected && !this.quiet)
      this.msgBoxSrv.showWarnMsg("SERVER CONNECTION CLOSED");
    super.onClose();
  }

  protected onError() {
    if (!this.quiet)
      this.msgBoxSrv.showErrorMsg("SERVER CONNECTION ERROR");
    super.onError();
  }
}
